import { apiSlice } from './apiSlice';
import type { ApiResponse } from '../../types';

export interface CarrierAgreementSummary {
  id: number;
  routeId: number;
  carrierId: number | null;
  number: string | null;
  date: string | null;
  price: string | number | null;
  createdAt: string;
}

export interface CarrierAgreementPenaltyRow {
  id: number;
  agreementId: number;
  templateId: number | null;
  name: string;
  code: string;
  type: string;
  value: string | number;
  perDay: boolean;
  maxAmount: string | number | null;
  requiresManualInput: boolean;
  /** С шаблона договора (для UI). */
  requiresComment?: boolean;
  createdAt: string;
}

export type UpdateAgreementPenaltyBody = {
  type: string;
  value: number;
  perDay: boolean;
  maxAmount: number | null;
  requiresManualInput: boolean;
};

export const carrierAgreementsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCarrierAgreementByRoute: builder.query<CarrierAgreementSummary, number>({
      query: (routeId) => ({
        url: `/carrier-agreements/by-route/${routeId}`,
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<CarrierAgreementSummary>) => response.data!,
      providesTags: (result, error, routeId) => [{ type: 'CarrierAgreement', id: `route-${routeId}` }]
    }),

    getCarrierAgreementPenalties: builder.query<CarrierAgreementPenaltyRow[], number>({
      query: (agreementId) => ({
        url: `/carrier-agreements/${agreementId}/penalties`,
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<CarrierAgreementPenaltyRow[]>) => response.data || [],
      providesTags: (result, error, agreementId) => [
        { type: 'CarrierAgreement', id: `penalties-${agreementId}` }
      ]
    }),

    updateCarrierAgreementPenalty: builder.mutation<
      CarrierAgreementPenaltyRow,
      { agreementId: number; penaltyId: number; body: UpdateAgreementPenaltyBody }
    >({
      query: ({ agreementId, penaltyId, body }) => ({
        url: `/carrier-agreements/${agreementId}/penalties/${penaltyId}`,
        method: 'PUT',
        body
      }),
      transformResponse: (response: ApiResponse<CarrierAgreementPenaltyRow>) => response.data!,
      invalidatesTags: (result, error, { agreementId }) => [
        { type: 'CarrierAgreement', id: `penalties-${agreementId}` }
      ]
    })
  })
});

export const {
  useGetCarrierAgreementByRouteQuery,
  useLazyGetCarrierAgreementByRouteQuery,
  useGetCarrierAgreementPenaltiesQuery,
  useLazyGetCarrierAgreementPenaltiesQuery,
  useUpdateCarrierAgreementPenaltyMutation
} = carrierAgreementsApi;
